import { axiosApi } from '../axios-api';

const MAX_CACHE = 50;
const memoryCache = new Map();

function cacheKey(url, useFirstPixel) {
  return `${url}|${useFirstPixel ? 1 : 0}`;
}

export async function fetchAutocropBbox(url, useFirstPixel) {
  if (!url) return { cropped: false, bbox: null };

  const key = cacheKey(url, useFirstPixel);
  if (memoryCache.has(key)) {
    return memoryCache.get(key);
  }

  const { data } = await axiosApi.post('/v2/images/autocrop/', {
    url,
    use_first_pixel: Boolean(useFirstPixel),
  });

  if (memoryCache.size >= MAX_CACHE) {
    const oldestKey = memoryCache.keys().next().value;
    memoryCache.delete(oldestKey);
  }
  memoryCache.set(key, data);
  return data;
}

export function clearAutocropCache() {
  memoryCache.clear();
}
